import * as React from 'react';
import { DestinationRefinementCard } from './destination-refinement-card';
import { PwaHsrPropertyDestinationRefinement } from 'src/common/__generated__/api';
import { classNames } from 'uitk-react-utils';

export interface DestinationRefinementListProps {
  title: string;
  destinations: PwaHsrPropertyDestinationRefinement.Destinations[];
  showAffinities?: boolean;
  showDescription?: boolean;
}

export const DestinationRefinementList: React.FunctionComponent<DestinationRefinementListProps> = ({
  destinations,
  title,
  showAffinities,
  showDescription
}) => (
  <li className="uitk-cell uitk-grid listing" data-stid="destination-refinement-list">
    <h3 className="uitk-type-500">{title}</h3>
    <ol className="uitk-grid no-bullet all-b-margin-three all-t-margin-three">
      {destinations.map((destination, position) => {
        const classes = classNames('uitk-cell uitk-flex uitk-flex-align-items-stretch m-cell-1-2 l-cell-1-2 xl-cell-1-2', {
          ['all-r-padding-three']: position === 0
        });

        return (
          <li className={classes} key={`refined-destination-${position}`}>
            {destination && <DestinationRefinementCard {...{ destination, position, showDescription, showAffinities }} />}
          </li>
        );
      })}
    </ol>
  </li>
);
